import Icon from '../components/Icon.vue'

Icon.register({
  'mars-double': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M340 0c6.6 0 12 5.4 12 12v79c0 7.2-5.9 12-12.1 12-2.9 0-6-1.1-8.4-3.5l-16.9-16.9-48.7 48.7c14 22.2 22.1 48.5 22.1 76.7 0 79.5-64.5 144-144 144s-144-64.5-144-144 64.5-144 144-144c28.2 0 54.5 8.1 76.7 22.1l48.7-48.7-16.9-16.9c-7.5-7.6-2.2-20.5 8.5-20.5h79zM144 288c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80zM500 159.9c6.6 0 12 5.4 12 12.1v79c0 7.2-5.9 12-12.1 12-3 0-6-1.1-8.4-3.5l-16.9-16.9-48.7 48.7c14 22.2 22.1 48.5 22.1 76.7 0 79.5-64.5 144-144 144-74.4 0-135.6-56.4-143.2-128.9 21.8-2 43.3-8.2 63.3-18.4-0.1 1-0.1 2.1-0.1 3.2 0 44.1 35.9 80 80 80s80-35.9 80-80c0-44.1-35.9-80-80-80-1 0-2.1 0.1-3.2 0.1 10.2-20 16.3-41.5 18.4-63.3 22.5 2.4 43.3 9.9 61.5 21.3l48.7-48.7-16.9-16.9c-7.5-7.6-2.2-20.5 8.5-20.5h79z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mars-double.js
// module id = 1548
// module chunks = 0